import { Routes, Route, Navigate } from 'react-router-dom'
import MasterDashboard from '../pages/dashboard/MasterDashboard'
import TenantsPage from '../pages/master/TenantsPage'
import NewTenantPage from '../pages/master/NewTenantPage'
import TenantDetailsPage from '../pages/master/TenantDetailsPage'
import CompaniesPage from '../pages/master/CompaniesPage'
import NewCompanyPage from '../pages/master/NewCompanyPage'
import CompanyDetailsPage from '../pages/master/CompanyDetailsPage'
import UsersPage from '../pages/master/UsersPage'
import UserDetailsPage from '../pages/master/UserDetailsPage'
import InviteUserPage from '../pages/master/InviteUserPage'
import BillingPage from '../pages/master/BillingPage'
import AnalyticsPage from '../pages/master/AnalyticsPage'
import SettingsPage from '../pages/master/SettingsPage'
import PlatformAgentsPage from '../pages/master/PlatformAgentsPage'
import InviteAgentPage from '../pages/master/InviteAgentPage'
import ErrorsPage from '../pages/master/ErrorsPage'
import EmailsPage from '../pages/master/EmailsPage'
import ControlTowerPage from '../pages/master/ControlTowerPage'
import PendingShippersPage from '../pages/master/PendingShippersPage'

export default function MasterRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<MasterDashboard />} />
      <Route path="/tenants" element={<TenantsPage />} />
      <Route path="/tenants/new" element={<NewTenantPage />} />
      <Route path="/tenants/:id" element={<TenantDetailsPage />} />
      <Route path="/companies" element={<CompaniesPage />} />
      <Route path="/pending-shippers" element={<PendingShippersPage />} />
      <Route path="/companies/new" element={<NewCompanyPage />} />
      <Route path="/companies/:id" element={<CompanyDetailsPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/users/invite" element={<InviteUserPage />} />
      <Route path="/users/:id" element={<UserDetailsPage />} />
      <Route path="/platform-agents" element={<PlatformAgentsPage />} />
      <Route path="/invite-agent" element={<InviteAgentPage />} />
      <Route path="/errors" element={<ErrorsPage />} />
      <Route path="/emails" element={<EmailsPage />} />
      <Route path="/control-tower" element={<ControlTowerPage />} />
      <Route path="/billing" element={<BillingPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/settings" element={<SettingsPage />} />

      {/* Redirect /master to /master/dashboard */}
      <Route path="/" element={<Navigate to="/master/dashboard" replace />} />

      {/* 404 within master routes */}
      <Route path="*" element={<div>Página não encontrada</div>} />
    </Routes>
  )
}
